import { render, staticRenderFns } from "./LabelLayouts.vue?vue&type=template&id=89951d36&scoped=true"
import script from "./LabelLayouts.vue?vue&type=script&lang=ts"
export * from "./LabelLayouts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89951d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89951d36')) {
      api.createRecord('89951d36', component.options)
    } else {
      api.reload('89951d36', component.options)
    }
    module.hot.accept("./LabelLayouts.vue?vue&type=template&id=89951d36&scoped=true", function () {
      api.rerender('89951d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/LabelLayouts.vue"
export default component.exports